(function (app, ng) {
    var addingItem = false;
/*
    app.directive("dndAdd", ["figDndService", "$document", "$timeout", function (figDndService, $document, $timeout) {
        return {
            link: function (scope, elem) {
                elem[0].draggable = "true";
                elem[0].style.background = "transparent";

                var darkenClass = " dnd-darken";
                var dropperClass = " dnd-dropper";

                var clone = elem.clone();
                clone[0].className += dropperClass;
                clone[0].style.background = "none";

                elem.on("dragstart", function (e) {
                    var ev = e.originalEvent;

                    //console.log("dragstart from directive");
                    //see http://mdn.github.io/drag-and-drop/copy-move-DataTransfer.html
                    ev.effectAllowed = "copyMove";
                    ev.dropEffect = "copy";

                    ev.dataTransfer.setData("source", "drag-and-drop");

                    if (ev.dataTransfer.setDragImage) //IE does not support
                        ev.dataTransfer.setDragImage(clone[0], clone[0].clientWidth, clone[0].clientHeight);

                    $timeout(function () {
                        e.preventDefault();

                        figDndService.beginDrag();
                    });
                });

                var func = function (e) {
                    e.preventDefault();
                    figDndService.endDrag();
                    $document[0].body.className = $document[0].body.className.replace(darkenClass, "");
                    elem[0].className = elem[0].className.replace(dropperClass, "");

                    //e.originalEvent.dataTransfer.clearData(); //firefox throws NoModificationAllowedError: Modifications are not allowed for this document
                };

                $document.on("dragend", func);
                scope.$on("$destroy", function () {
                    $document.off("dragend", func);
                });

                elem.on("click", function (e) {
                    if (!addingItem) {
                        $timeout(function () {
                            e.preventDefault();
                            figDndService.beginDrag();
                            addingItem = true;
                        });
                    }
                });

                var clickFunc = function(e) {
                    if (addingItem) {
                        $document[0].body.className = $document[0].body.className.replace(darkenClass, "");
                        elem[0].className = elem[0].className.replace(dropperClass, "");

                        //$timeout(function () {
                        e.preventDefault();
                        figDndService.endDrag();
                        //});
                        addingItem = false;
                    }
                };

                $document.on("click", clickFunc);
                scope.$on("$destroy", function () {
                    $document.off("click", clickFunc);
                });
            }
        };
    }]);

    app.directive("dndZone", [function () {
        return {
            scope: { zone: "@dndZone", stickyNotes: "<", clientId: "<" },
            controllerAs: "dndCtrl",
            bindToController: true,
            controller: [function () {
                var $ctrl = this;

                this.$onInit = function () {
                    this.items = this.items.filter(function (item) { return item.Location === $ctrl.zone; });
                    var listeners = [];

                    ng.extend($ctrl,
                    {
                        registerCallback: registerCallback,
                        onNewItem: onNewItem
                    });

                    function registerCallback(callbackFn) {
                        listeners.push(callbackFn);
                    }

                    function onNewItem() {
                        listeners.forEach(function (listener) { listener(); });
                    }
                };
            }]
        };
    }]);

    // from advisor crm - will this be used?

    //app.directive("stickyNoteCounter", [function () {
    //    return {
    //        scope: {},
    //        require: ["^stickyNoteZone", "stickyNoteCounter"],
    //        template: "<div class='sticky-note-counter' ng-if='counter.count>0'>{{counter.count}}</div>",
    //        controllerAs: "counter",
    //        controller: [function () { }],
    //        link: function (scope, elem, attr, ctrls) {
    //            var stickyNoteZoneCtrl = ctrls[0];
    //            var myCtrl = ctrls[1];
    //            myCtrl.count = stickyNoteZoneCtrl.stickyNotes.length;

    //            stickyNoteZoneCtrl.registerCallback(function () {
    //                myCtrl.count++;
    //            });
    //        }
    //    };
    //}]);

    
    app.directive("dndDrop", ["figDndService", "$mdDialog", function (figDndService) {
        var draggingClass = "dnd-dragging";
        return {
            require: ["^dndZone"],
            link: function (scope, elem, attr, ctrls) {
                var dndZoneCtrl = ctrls[0];
                var zone = dndZoneCtrl.zone;
                var unsubscribeBeginDrag = figDndService.onBeginDrag(function () {
                    elem.addClass(draggingClass);
                });
                var unsubscribeEndDrag = figDndService.onEndDrag(function () {
                    elem.removeClass(draggingClass);
                });
                scope.$on("$destroy", function () {
                    unsubscribeBeginDrag();
                    unsubscribeEndDrag();
                });
                elem.on("drop", function (e) {
                    elem.removeClass("hover");

                    var ev = e.originalEvent;

                    if (ev.dataTransfer) {
                        var source = ev.dataTransfer.getData("source");
                        if (source !== "drag-and-drop") return;
                    }
                    e.preventDefault();

                    // this is where we would decide what to do on drop

                    // use calendar day as location in zone?
                });

                elem.on("click", function (e) {
                    if (!addingItem) return;

                    elem.removeClass("hover");

                    var ev = e.originalEvent;

                    if (ev.dataTransfer) {
                        var source = ev.dataTransfer.getData("source");
                        if (source !== "sticky-note-add") return;
                    }
                    e.preventDefault();

                    // this is where we would decide what to do on drop
                });
                //this event handler has to be here for dnd events to work
                elem.on("dragover", function (e) {
                    e.preventDefault();
                    elem.addClass("hover");
                });
                elem.on("dragexit dragleave", function () { elem.removeClass("hover"); }); //if we want to do something when the mouse out of here
            }
        };
    }]);

    app.directive("dndOverlay", ["figDndService", function (figDndService) {
        return {
            link: function (scope, elem) {
                elem.addClass("dnd-overlay");

                var unsubscribeBeginDrag = figDndService.onBeginDrag(function () {
                    elem[0].style.zIndex = 100;
                    elem[0].style.opacity = 0.6;
                });

                var unsubscribeEndDrag = figDndService.onEndDrag(function () {
                    elem[0].style.zIndex = -1;
                    elem[0].style.opacity = 0;
                });

                scope.$on("$destroy", function () {
                    unsubscribeBeginDrag();
                    unsubscribeEndDrag();
                });
            }
        };
    }]);
    */
})(window.app, window.angular); // jshint ignore:line